var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('span',{staticClass:"layout",on:{"click":_vm.toggleLayout}},[_c('svg-icon',{attrs:{"icon-name":"layout"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }